module.exports = __webpack_public_path__ + "static/media/instagram.a8e2aea7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/instagram.svg
// module id = 222
// module chunks = 2